import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import 'material-design-icons-iconfont/dist/material-design-icons.css' // Offline font
import 'roboto-fontface/css/roboto/roboto-fontface.css';
Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'md', // default - only for display purposes
  },
  theme: {
    themes: {
      light: {
        primary: '#336699',
        secondary: '#464f5b',
        accent: '#f1f1f1',
        error: '#fa6767',
        info: '#44badc',
        success: '#42d29d',
        warning: '#f9bc0d'
      },
      dark: {
        primary: '#336699',
        secondary: '#464f5b',
        accent: '#f1f1f1',
        error: '#fa6767',
        info: '#44badc',
        success: '#42d29d',
        warning: '#f9bc0d'
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/plugins/vuetify.js